import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ThemeValues } from "../ThemeUsage/theme";
import PageSubTitle from "../Displays/PageSubTitle";
import { Link, Stack, useTheme } from "@mui/material";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";

const SmartChargingFooter = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const themeName = useContext(ThemeContext);

  return (
    <Stack
      sx={{
        pt: 8,
        pb: 12,
        backgroundColor: theme.palette.background.default,
      }}
      color={theme.palette.background.default}
      alignItems="center"
    >
      <Stack
        sx={{
          width: "100%",
          px: 4,
          flexDirection: { xs: "column" },
          justifyContent: undefined,
          alignItems: { xs: "center", sm: "start" },
          maxWidth: "880px",
        }}
        gap={themeName === ThemeValues.SMA ? 0 : 6}
      >
        <Stack direction="row" flexWrap={"wrap"} gap={3} mb={2}>
          <Link
            sx={(theme) => ({
              textDecoration: "none",
            })}
            href="https://www.lichtblick.de/impressum/"
            target="_blank"
          >
            <PageSubTitle
              color={theme.palette.mainFont.primary}
              text={t("footer.legalNotice")}
              sx={{
                fontSize: "12px",
                lineHeight: "18px",
              }}
            />
          </Link>
          <Link
            sx={(theme) => ({
              textDecoration: "none",
            })}
            href="https://www.lichtblick.de/datenschutz/"
            target="_blank"
          >
            <PageSubTitle
              color={theme.palette.mainFont.primary}
              text={t("footer.privacy")}
              sx={{
                fontSize: "12px",
                lineHeight: "18px",
              }}
            />
          </Link>
          <Link
            sx={(theme) => ({
              textDecoration: "none",
              fontSize: "14px",
            })}
            href="https://www.lichtblick.de/kontakt/"
            target="_blank"
          >
            <PageSubTitle
              color={theme.palette.mainFont.primary}
              text={t("footer.contact")}
              sx={{
                fontSize: "12px",
                lineHeight: "18px",
              }}
            />
          </Link>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SmartChargingFooter;
